"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * # Measures
 * Spacing is used for margin on any element or padding on containers, but can be used for other
 * properties that position elements.
 * * Larger containers, such as `Card` or `Modal`, use `spacing`.
 * * `spacingHalf` and `spacingQuarter` are primarily for horizontal spacing between smaller elements.
 * * Just because a desired value equals 20, 10, or 5 pixels, does not mean it's appropriate to
 * use spacing variables.
 *
 * @valueSet
 */
var measures = {
  spacingXSmall: '4px',
  spacingSmall: '8px',
  spacingMedium: '12px',
  spacingLarge: '16px',
  spacingXLarge: '24px',
  spacingXXLarge: '32px',
  spacingXXXLarge: '40px',
  fontSizeSmall: '12px',
  fontSize: '14px',
  fontSizeLarge: '16px',
  fontSizeXLarge: '18px',
  fontSizeXXLarge: '24px',
  lineHeight: '20px',
  inputHeight: '32px',
  borderRadius: '4px'
};
var _default = measures;
exports["default"] = _default;